import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      /loading chunk/i.test(error?.message || "") ||
      /dynamically imported module/i.test(error?.message || "");
    return { hasError: true, isChunkError };
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAF0E6] px-4">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#228B22] to-[#F5B800] flex items-center justify-center">
              <span className="text-white text-2xl">!</span>
            </div>
            <h2 className="text-2xl font-bold text-[#228B22] mb-2">
              {this.state.isChunkError ? "Oppdatering tilgjengelig" : "Noe gikk galt"}
            </h2>
            <p className="text-[#228B22]/70 mb-6">
              {this.state.isChunkError
                ? "En ny versjon av Vennli er tilgjengelig. Last inn siden på nytt for å fortsette."
                : "Beklager, en uventet feil oppstod. Prøv å laste inn siden på nytt."}
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReload}
                className="px-6 py-3 bg-[#228B22] text-white rounded-full font-medium hover:bg-[#1a6b1a] transition-colors"
              >
                Last inn på nytt
              </button>
              <button
                onClick={this.handleGoHome}
                className="px-6 py-3 border-2 border-[#228B22] text-[#228B22] rounded-full font-medium hover:bg-[#228B22]/5 transition-colors"
              >
                Gå til forsiden
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
